module.exports = __webpack_public_path__ + "img/evtools.495e9997.png";